import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { getTeamsV2 } from '@/common/services/TeamsService'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { SERVER_DATA_LABELS, SERVER_DATA_SCOPE, type FetchOptionBase } from '@/common/types/cacheConstants'

function groupOptions() {
  return queryOptions({
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.TEAMS,
    }),
    staleTime: Infinity,
    queryFn: getTeamsV2,
  })
}

async function fetch(options: FetchOptionBase = {}) {
  const { staleTime } = options
  const [result] = await Promise.all([
    queryClient.fetchQuery(merge(groupOptions(), { staleTime })),
    localizationServerData.fetch({
      prefixes: SERVER_DATA_LABELS.TEAMS,
      staleTime,
    }),
  ])
  return result
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.TEAMS,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
